import { useState } from 'react'
import { useGetCommandsQuery } from '@/entities/command'

/** Окно монитора: идущие и очередь сверху, дальше последние завершённые. Листать негде. */
const WINDOW = { page: 1, pageSize: 20 }

/** Пока есть что ждать, монитор перечитывает очередь: WS-события `command.updated` ещё нет (`BE-14`). */
const POLL_MS = 10_000

/**
 * Очередь команд для кнопки в шапке и модалки — один запрос на обоих: аргумент общий, кеш
 * RTK Query один. Опрос включается, только пока есть идущие или ждущие команды. Интервал —
 * параметр хука, а есть ли что ждать, известно из его же ответа, поэтому признак хранится
 * состоянием и обновляется прямо в рендере: React перерисует компонент до коммита.
 */
export function useProcessMonitor() {
  const [polling, setPolling] = useState(false)
  const query = useGetCommandsQuery(WINDOW, { pollingInterval: polling ? POLL_MS : 0 })

  const summary = query.data?.summary
  const active = (summary?.running ?? 0) + (summary?.queued ?? 0)
  if (polling !== active > 0) setPolling(active > 0)

  return query
}
